import React, { useState } from "react";

// Slug → env var name mapping
// REACT_APP_DECK_PASSWORD_BELITEBIO_2026, REACT_APP_DECK_PASSWORD_ALKERMES_CDH, etc.
function envKeyForSlug(slug) {
  const key = slug.toUpperCase().replace(/-/g, "_").replace(/[^A-Z0-9_]/g, "_");
  return `REACT_APP_DECK_PASSWORD_${key}`;
}

function sessionKey(slug) {
  return `catalyst_deck_unlocked_${slug}`;
}

export default function PasswordGate({ slug, children }) {
  const envKey = envKeyForSlug(slug);
  const expectedPassword = process.env[envKey] || null;

  const [unlocked, setUnlocked] = useState(() => {
    try {
      return sessionStorage.getItem(sessionKey(slug)) === "1";
    } catch {
      return false;
    }
  });

  const [input, setInput] = useState("");
  const [error, setError] = useState(null);

  if (unlocked) {
    return children;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!expectedPassword) {
      setError("Password not configured for this deck. Contact Lou.");
      return;
    }
    if (input === expectedPassword) {
      try {
        sessionStorage.setItem(sessionKey(slug), "1");
      } catch {
        // sessionStorage unavailable; proceed anyway
      }
      setUnlocked(true);
    } else {
      setError("Incorrect password. Please try again.");
      setInput("");
    }
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "#121531",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Georgia', serif",
      padding: "0 20px",
    }}>
      <div style={{
        background: "#1A1F40",
        border: "1px solid rgba(66,164,217,0.25)",
        borderRadius: 12,
        padding: "40px 36px",
        maxWidth: 380,
        width: "100%",
        boxSizing: "border-box",
        textAlign: "center",
      }}>
        <div style={{
          fontFamily: "Montserrat, sans-serif",
          fontSize: 11,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: "#42A4D9",
          marginBottom: 16,
        }}>
          Catalyst Medical Education
        </div>
        <div style={{
          fontFamily: "'Georgia', serif",
          fontSize: 22,
          fontWeight: 700,
          color: "#F4F6FA",
          marginBottom: 8,
        }}>
          Protected Presentation
        </div>
        <div style={{
          fontFamily: "Montserrat, sans-serif",
          fontSize: 13,
          color: "#8892A4",
          marginBottom: 28,
        }}>
          Enter the password provided by Catalyst Medical Education to continue.
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={input}
            onChange={e => { setInput(e.target.value); setError(null); }}
            placeholder="Password"
            autoFocus
            style={{
              width: "100%",
              padding: "12px 16px",
              borderRadius: 8,
              border: error
                ? "1.5px solid #EF4444"
                : "1px solid rgba(66,164,217,0.3)",
              background: "#0E1128",
              color: "#F4F6FA",
              fontFamily: "Montserrat, sans-serif",
              fontSize: 14,
              boxSizing: "border-box",
              marginBottom: 12,
              outline: "none",
            }}
          />
          {error && (
            <div style={{
              color: "#EF4444",
              fontFamily: "Montserrat, sans-serif",
              fontSize: 12,
              marginBottom: 12,
            }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: 8,
              border: "none",
              background: "linear-gradient(135deg, #1A6FA8, #42A4D9)",
              color: "#fff",
              fontFamily: "Montserrat, sans-serif",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              letterSpacing: "0.02em",
            }}
          >
            Continue →
          </button>
        </form>
      </div>
    </div>
  );
}
